import React from 'react';
import BooleanFacet from './BooleanFacet';
import RangeFacet from './RangeFacet';
import MultiChoiceFacet from './MultiChoiceFacet';
import StarFacet from './StarFacet';
import UnknownFacet from './UnknownFacet';
import PropTypes from 'prop-types';
import getSearchValues from '../../../functions/getSearchValues';
import { getFacetFromSlug } from '../../../functions/getFacetFromSlug';

export const FacetFactory = ({ searchParameters, facets, type, slug, onChange,  ...props }) => {
  const searchValue = getSearchValues({ searchParameters, slug, type });
  const selectedManufacturers = getSearchValues({ searchParameters, slug: 'manufacturer', type: 'names' });
  const facetData = getFacetFromSlug({ facets, slug });

  if (type === 'bool') {
    return <BooleanFacet  {...props} count={facetData} type={type} slug={slug} selected={searchValue}
      onChange={(newValue) => {
        onChange({ slug, newValue });
      }} />;
  }
  if (type === 'int' || type === 'float') {
    return <RangeFacet min={facetData.minValue} max={facetData.maxValue} {...props}
      onChange={(newValue) => onChange({ slug, newValue })} type={type} slug={slug}
      requestedMin={searchValue?.min} requestedMax={searchValue?.max} />;
  }

  if (type === 'name' || type === 'names' || type === 'term') {
    return <MultiChoiceFacet {...props} selectedManufacturers={selectedManufacturers} type={type} slug={slug}
      onChange={(newValue) => onChange({ slug, newValue })} facets={facetData}
      selected={searchValue?.length ? searchValue : []} />;
  }
  if (type === 'stars') {
    return <StarFacet {...props} type={type} slug={slug} onChange={(newValue) => onChange({ slug, newValue })}
      selected={searchValue} facets={facetData} />;
  }
  return <UnknownFacet type={type} slug={slug} onChange={(newValue) => onChange({ slug, newValue })}
    selected={searchValue} {...props} facets={facetData} />;
};

FacetFactory.propTypes = {
  onChange: PropTypes.func.isRequired,
  searchParameters: PropTypes.shape({}).isRequired,
  facets: PropTypes.shape({}).isRequired,
  type: PropTypes.oneOf(['stars', 'name', 'names', 'term', 'int', 'float', 'bool']).isRequired,
  slug: PropTypes.string.isRequired,
};
FacetFactory.defaultProps = {
  onChange: () => {
  }
};

export default FacetFactory;
